export default __webpack_public_path__ + "static/media/info-circle-red.97dd063c.svg";